// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1c586025","238":"96a0346a","239":"8ddf8945","462":"90b892d9","488":"1f8fd1ae","551":"d2e0879d","555":"4d588b73"}[chunkId] + ".chunk.js";
};